import _ from "lodash";
import { Worker } from "../../models/Interfaces/Worker";
import { Control } from "../../models/Interfaces/Control";
import { status as ControlStatus } from "../../enums/control";

export const getMissionControl = (
  worker: Worker,
  mid: string | undefined
): Control | undefined => {
  if (!worker.controles || !mid) {
    return undefined;
  }

  const missionControls = worker.controles.filter(
    control =>
      control.mission &&
      String(control.mission.id) === String(mid)
  );

  if (missionControls.length === 0) {
    return undefined;
  }

  return missionControls.reduce((latest, control) =>
    Number(control.id) > Number(latest.id) ? control : latest
  );
};

export const getExistingControlComment = (
  worker: Worker,
  mid: string | undefined
): string => {
  const missionControl = getMissionControl(worker, mid);
  if (missionControl?.comment) {
    return missionControl.comment;
  }

  return worker.controle_comment ?? "";
};

export const getAllWorkers = (workers: Worker[], mid: string | undefined) => {
  return workers;
};

export const getCheckedWorkers = (
  workers: Worker[],
  mid: string | undefined
) => {
  const items = workers?.filter(w => {
    const results =
      w && w.controles && w.controles.length > 0
        ? w.controles?.filter(
          c =>
            c.status === ControlStatus.VALIDATED &&
            String(c.mission && c.mission.id) === String(mid)
        )
        : [];
    return !_.isEmpty(results);
  });

  return items;
};

export const getApprouvedWorkers = (
  workers: Worker[],
  mid: string | undefined
) => {
  const items = workers?.filter(w => {
    const results =
      w && w.controles && w.controles.length > 0
        ? w.controles?.filter(
          // @todo: check against comment for test prupose
          c =>
            c.status === ControlStatus.APPROUVED &&
            String(c.mission && c.mission.id) === String(mid)
        )
        : [];
    return !_.isEmpty(results);
  });
  return items;
};

export const getRefusedWorkers = (
  workers: Worker[],
  mid: string | undefined
) => {
  const items = workers?.filter(w => {
    const results =
      w && w.controles && w.controles.length > 0
        ? w.controles?.filter(
          c =>
            c.status === ControlStatus.REFUSED &&
            String(c.mission && c.mission.id) === String(mid)
        )
        : [];
    return !_.isEmpty(results);
  });
  return items;
};

export const getNotControlledWorkers = (
  workers: Worker[],
  mid: string | undefined
) => {
  const items = workers?.filter(worker => {
    return worker && worker.controles && worker.controles.length > 0
      ? worker.controles?.find(
        control => String(control.mission && control.mission.id) === String(mid)
      ) === undefined
      : true
  })

  return items
}